import { createFileRoute } from '@tanstack/react-router';
import { ResultsPane } from '../../-components/phase-views/ResultsPane';

export const Route = createFileRoute('/_app/simops/$studyId/results/compare')({
  component: () => <ResultsPane mode="compare" />,
});
